import { InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import React, { FC, memo, useCallback, useState } from "react";
import { FormPasswordTextFieldProps } from "./types";

const useStyles = makeStyles({
  icon: {
    color: "#6c6c6c",
    transition: "0.3s ease fill",
    ".Mui-focused &": {
      color: "#4B4B4B",
    },
    ".MuiInputBase-root:hover:not(.Mui-disabled) &": {
      color: "#4B4B4B",
    },
  },
  iconWrap: {
    ".Mui-disabled &": {
      pointerEvents: "none",
    },
    ".MuiInputBase-root:not(.Mui-disabled) &": {
      cursor: "pointer",
    },
    paddingLeft: 16,
    paddingRight: 16,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "0.3s ease border-color",
    ".MuiInputBase-root:hover:not(.Mui-disabled):not(.Mui-error) &": {
      borderLeftColor: "rgb(92, 92, 92)",
    },
    ".Mui-error &": {
      borderLeftColor: "#f44336",
    },
  },
});

const FormPasswordField: FC<FormPasswordTextFieldProps> = ({
  validationSuccess,
  required,
  showError,
  InputProps,
  InputLabelProps,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const classes = useStyles();

  const handleClickShowPassword = useCallback(() => {
    setShowPassword((show) => !show);
  }, []);

  return (
    <TextField
      type={showPassword ? "text" : "password"}
      InputProps={{
        required,
        endAdornment: (
          <InputAdornment position="end">
            <div className={classes.iconWrap} onClick={handleClickShowPassword}>
              {showPassword ? (
                <VisibilityOutlinedIcon className={classes.icon} />
              ) : (
                <VisibilityOffOutlinedIcon className={classes.icon} />
              )}
            </div>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      InputLabelProps={InputLabelProps}
      {...props}
      variant="outlined"
    />
  );
};

export default memo(FormPasswordField);
